import { PaymentElement } from "@stripe/react-stripe-js";
import { useEffect, useState } from "react";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import SecondaryButton from "../SecondaryButton";
import { AlertColor, Button, Checkbox, FormControlLabel, Typography } from "@mui/material";
import { ConfirmPaymentData, StripeError, StripeErrorType } from "@stripe/stripe-js";
import { Toast } from "../alerts/toast";
import ApplicantStatementModal from "../modals/ApplicantStatement";
import { logActivityAsync } from "../../objects/events/loadEvents";
import { Policy } from "../../objects/policy";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";



function PaymentForm(props: any) {
  const {
    policyObject,
    options,
    onStripeSuccess,
    setOpenSpinner,
    setCloseSpinner
  } = props;

  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const policy = policyObject as Policy;
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [isYesAutoPay, setIsYesAutoPay] = useState(true);
  const [isYesEsig, setIsYesEsig] = useState(true);
  const[isToastOpen, setIsToastOpen] = useState(false);
  const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");
  const[alertMessages, setAlertMessages] = useState<string[]>([]);

  const[isOpenAgreement, setIsOpenAgreement] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    var messages:any = [];
    if(!isYesAutoPay){
      messages.push("Oops! We only do automatic payments at Alset.");
    }      
    
    if(!isYesEsig){
      messages.push("Oops! You must agree to the Applicant Agreement.");
    }      
           

    if(messages.length>0){
        setAlertMessages(messages);
        setIsToastOpen(true);
        setToastSeverity("warning");

        return;
    }
   

    setOpenSpinner();
    if (!stripe || !elements) {
      console.error("error loading stripe");
      setCloseSpinner();
      return;
    }

    setIsLoading(true);

    const confirmParams = {
      return_url: "http://localhost:3001",
  
    } as ConfirmPaymentData;
    
    const { error, paymentIntent } = await stripe.confirmPayment({
      elements,
      confirmParams,
      redirect: "if_required"
    });

    if (error?.type === "card_error" || error?.type === "validation_error") {
      
      await logActivityAsync(policy?.policyNumber ?? "", {
        recordKey: policy?.policyNumber,
        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
        action: "error_activity",
        subject: "Payment Screen - Payment Processor Error",
        message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
        isException: true,
        error: error?.message ?? "Empty Response",
        level: "ERROR",
        isSent: false
      });
      
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set("returnUrl", "/payment");            
      navigate("/error?" + queryParams.toString());
      
      setIsLoading(false);
      setCloseSpinner();
      return
    }

    if ((paymentIntent?.id ?? "") === "") {
      setIsLoading(false);
      setCloseSpinner();
      return;
    }

    onStripeSuccess(paymentIntent);

    setIsLoading(false);
  };

  const onLoadError = async (e:StripeError)=>{
    
    await logActivityAsync(policy?.policyNumber ?? "", {
      recordKey: policy?.policyNumber,
      transactionDate: dayjs(new Date().toUTCString()).toISOString(),
      action: "error_activity",
      subject: "Payment Screen - Form Initialization Failed",
      message: `Quote# ${policy?.policyNumber} - ${policy?.insuredFirstName} ${policy?.insuredLastName}, ${policy?.emailAddress ?? "NO EMAIL"}`,
      isException: true,
      error: e.message ?? "Empty Response",
      level: "ERROR",
      isSent: false
    });

    var queryParams = new URLSearchParams(window.location.search);
    queryParams.set("returnUrl", "/");            
    navigate("/error?" + queryParams.toString());

    return;
  };

  return (
    <>
      <form id="payment-form" onSubmit={handleSubmit}>
        <PaymentElement  options={options} onLoadError={(e)=>{ onLoadError(e.error); }}/>
        <br />
        <FormControlLabel label="By purchasing this policy, you agree to automatic monthly payments." control={
          <Checkbox name="chkbxAutoPay" checked={isYesAutoPay} value={"false"} onChange={(e) => { setIsYesAutoPay(!isYesAutoPay) }} />
        } />
        <br />
        <FormControlLabel label={
            <Typography>
              By clicking "Pay Now", you agree to the <span className="text-blue-500 hover:text-blue-700 underline underline-offset-2" onClick={()=>{ setIsOpenAgreement(true); }}>Applicant Agreement</span> and this acts as your
              electronic signature.

            </Typography>} control={
          <Checkbox name="chkbxAcknowledge" checked={isYesEsig} value={"false"} onChange={(e) => { setIsYesEsig(!isYesEsig) }} />
        } />
        <br />
        <Button type="submit" disabled={isLoading || !stripe || !elements} id="submit" variant="contained" className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/4 float-right" >
          <span id="button-text">
            {isLoading ? <div className="spinner" id="spinner">Processing...</div> : "Pay now"}
          </span>
        </Button>

        {message && <div id="payment-message">{message}</div>}
      </form>
      
      <ApplicantStatementModal onCloseModal={()=> setIsOpenAgreement(false)} isOpen={isOpenAgreement} />
      <Toast isOpen={isToastOpen} onClose={(e:any)=>{ setIsToastOpen(false); }} severity={toastSeverity} message={alertMessages} />
    </>
  );
}


export default PaymentForm;

//https://stripe.com/docs/js/elements_object/create_payment_element#payment_element_create-options-defaultValues
//https://stripe.com/docs/js/elements_object/create_payment_element
//https://stripe.com/docs/payments/quickstart
//https://stripe.com/docs/payments/payment-element